import { faWifiExclamation } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { Button, Text } from '@growtherapy/sprout-ui';

import { Translate } from '../i18n/Translate';
import { Toast } from '../toasts/Toast';
import { ModifiedToastAria, ToastVariant } from '../toasts/types';

export type UnstableInternetToastProps = ModifiedToastAria & {
  areVideoQualitySettingsAvailable?: boolean;
  onOpenSettings: () => void;
  isPerformanceMode: boolean;
};

export function UnstableInternetToast({
  contentProps,
  descriptionProps,
  isPerformanceMode,
  areVideoQualitySettingsAvailable = true,
  onOpenSettings,
  titleProps,
  ...toastAriaProps
}: UnstableInternetToastProps) {
  const t = useTranslate();

  return (
    <Toast {...toastAriaProps} icon={faWifiExclamation} variant={ToastVariant.Info}>
      <div {...contentProps}>
        <Text as='span' {...titleProps}>
          {t('telehealth-core:video.yourInternetConnectionIsUnstable')}{' '}
        </Text>
        <Text as='span' {...descriptionProps}>
          {isPerformanceMode || !areVideoQualitySettingsAvailable ? (
            t('telehealth-core:video.tryTurningOffYourCameraToImproveTheConnection')
          ) : (
            <Translate
              i18nKey='telehealth-core:video.tryChangingYourVideoQualityOrTurningOffYourCamera'
              components={{
                1: <Button className='text-inherit' use='link' onClick={onOpenSettings} />,
              }}
            />
          )}
        </Text>
      </div>
    </Toast>
  );
}
